import React, { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { generatePath, useHistory } from 'react-router-dom'
import { Formik, FormikHelpers } from 'formik'
import * as Yup from 'yup'

import ROUTES from 'app/routes'
import { NetworkWizardContext } from '../NetworkWizardContext'
import { LoaderOverlay } from 'components/Loader'
import { fieldsMessages } from 'components/Fields/messages'
import { AddNetworkFormValuesType } from './types'
import AddNetworkForm from './AddNetworkForm'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { useNetworkHomeJobsRouteParams } from 'features/networkAi/hooks'
import { DOMAIN_API_ERROR } from 'features/jobs/consts'
import { addNetworkThunk } from 'features/networkAi/NetworkWizard/slice'
import { mistOrganizationIdSelector } from 'features/networkAi/selectors'

// TODO: check that network already created then redirect?
function AddNetwork() {
  const { formatMessage } = useIntl()
  const dispatch = useAppDispatch()
  const history = useHistory()
  const { rootDomainId, jobId, homeId } = useNetworkHomeJobsRouteParams()
  const organizationId = useAppSelector(mistOrganizationIdSelector)
  const { job, domainId, isLoading, handleCloseWizard, refetchJobData } =
    useContext(NetworkWizardContext)

  const isPageDataLoading = !(job || domainId) || isLoading
  const initialValues: AddNetworkFormValuesType = {
    jobName: job?.name || '',
    location: undefined,
    isLocationChanged: false,
  }

  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        jobName: Yup.string()
          .trim()
          .required(formatMessage(fieldsMessages.requiredField)),
        location: Yup.object().required(
          formatMessage(fieldsMessages.requiredField)
        ),
      }),
    [formatMessage]
  )

  const handleSubmit = async (
    values: AddNetworkFormValuesType,
    { setStatus, resetForm }: FormikHelpers<AddNetworkFormValuesType>
  ) => {
    try {
      const { jobName, location, isLocationChanged } = values
      const newJobId = await dispatch(
        addNetworkThunk({
          domainId,
          jobId,
          jobName,
          oldJobLocation: job?.location,
          newJobLocation: location,
          isLocationChanged,
          organizationId,
          homeId,
          timezone: job?.homes[0].timezone,
        })
      )
      console.log('Job', newJobId)
      // TODO cover the case with hostless homes here, create a home as well

      refetchJobData()
      resetForm()

      const path = generatePath(ROUTES.networkAi.wizard.purchaseSubscription, {
        rootDomainId,
        jobId,
        homeId,
      })
      history.push(path)
    } catch (err) {
      if (err?.name === DOMAIN_API_ERROR.DOMAIN_JOB_EXISTS) {
        return setStatus({
          error: true,
          errorMessage: 'Job name should be unique!',
        })
      }
      setStatus({ error: true })
      console.log('Error creating Network Home', err)
    }
  }

  return (
    <>
      {isPageDataLoading ? (
        <LoaderOverlay isFullScreen />
      ) : (
        <Formik
          initialValues={initialValues}
          initialStatus={{
            error: false,
            errorMessage: undefined,
            isLoading: false,
          }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <AddNetworkForm job={job} handleCloseWizard={handleCloseWizard} />
        </Formik>
      )}
    </>
  )
}

export default AddNetwork
